<template>

  <li class="list-group-item integration-item">
    <div class="d-flex align-items-start">
      <div class="integration-logo mr-3">
        <img
          v-if="logo"
          :src="logo"
          :alt="title">
        <div
          v-else
          class="integration-logo-fallback">
          {{ initials }}
        </div>
      </div>
      <div class="flex-grow-1">
        <div class="d-flex align-items-center">
          <h6 class="mb-0 mr-2">{{ title }}</h6>
          <span
            v-if="category"
            class="badge badge-light">{{ category }}</span>
        </div>
        <p
          v-if="description"
          class="subtext mb-0 mt-1">{{ description }}</p>
      </div>
      <div class="ml-3">
        <button
          type="button"
          class="btn btn-outline-primary"
          :disabled="!canConnect"
          @click="showModal()">
          {{ canConnect ? $t('Connect') : $t('Connected') }}
        </button>
      </div>
    </div>

    <!--modal de conexão do conector (form ou custom)-->
    <component
      :is="connectComponent"
      v-if="show"
      :integration="integration"
      @close="hideModal()"
      @connected="onConnected()" />

  </li>

</template>

<script>
import connectors from './connectors'

export default {
  name: 'IntegrationItem',
  props: {
    integration: {
      type: Object,
      required: true
    },
    connected: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    connectComponent () {
      return connectors.getConnector(this.integration).connect
    },
    // integrações single instance só podem ser conectadas uma vez
    canConnect () {
      return this.integration.multi_instance ? true : !this.connected
    },
    title () {
      return this.integration.label || this.integration.integration || ''
    },
    description () {
      return this.integration.description || ''
    },
    logo () {
      return this.integration.logo || this.integration.logo_url || this.integration.image || this.integration.icon || null
    },
    category () {
      if (!this.integration.category) return null
      const key = 'integration_category_' + this.integration.category
      const label = this.$t(key)
      return label === key ? this.integration.category : label
    },
    initials () {
      return (this.title || '?').trim().charAt(0).toUpperCase()
    }
  },
  methods: {
    showModal () {
      this.show = true
    },
    hideModal () {
      this.show = false
    },
    onConnected () {
      this.hideModal()
      this.$emit('connected', this.integration)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .integration-item {
    display: block;
  }
  .integration-logo {
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .integration-logo img {
    max-width: 100%;
    max-height: 100%;
  }
  .integration-logo-fallback {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/Integrations/IntegrationItem.vue